import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
    LayoutDashboard, FileSearch, Users, Contact, Mail, GitBranch, BarChart3, Settings, Sparkles,
} from "lucide-react";

const TABS = [
    { to: "dashboard", icon: LayoutDashboard, label: "Dashboard", testId: "rec-nav-dashboard" },
    { to: "job-parser", icon: FileSearch, label: "Job Parser", testId: "rec-nav-parser" },
    { to: "candidate-search", icon: Users, label: "Candidate Search", testId: "rec-nav-search" },
    { to: "crm", icon: Contact, label: "Talent CRM", testId: "rec-nav-crm" },
    { to: "outreach", icon: Mail, label: "Outreach", testId: "rec-nav-outreach" },
    { to: "pipeline", icon: GitBranch, label: "Pipeline", testId: "rec-nav-pipeline" },
    { to: "analytics", icon: BarChart3, label: "Analytics", testId: "rec-nav-analytics" },
    { to: "settings", icon: Settings, label: "Settings", testId: "rec-nav-settings" },
];

export default function RecruitLayout() {
    return (
        <div data-testid="recruit-layout">
            <div className="mb-6 flex items-start gap-3 flex-wrap">
                <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-violet-500 to-fuchsia-600 flex items-center justify-center">
                    <Sparkles size={20} className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="overline">Command Center · Recruit</p>
                    <h1 className="mt-1 font-heading font-medium text-2xl sm:text-3xl tracking-tight text-foreground">
                        Simonara Recruit™
                    </h1>
                    <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
                        AI talent sourcing workspace for the Simonara team. Parse jobs, search internal + external candidates, run outreach, and grow the passport database.
                    </p>
                </div>
            </div>

            <div className="mb-6 overflow-x-auto -mx-1 px-1">
                <div className="inline-flex items-center gap-1 bg-muted/40 rounded-lg p-1 border border-border">
                    {TABS.map((t) => (
                        <NavLink
                            key={t.to}
                            to={t.to}
                            data-testid={t.testId}
                            className={({ isActive }) =>
                                `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium whitespace-nowrap transition ${isActive ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`
                            }
                        >
                            <t.icon size={14} /> {t.label}
                            {t.soon && (
                                <span className="ml-1 text-[9px] font-bold uppercase tracking-wider text-violet-500 bg-violet-500/10 rounded px-1 py-0.5">
                                    soon
                                </span>
                            )}
                        </NavLink>
                    ))}
                </div>
            </div>

            <Outlet />
        </div>
    );
}
